import React, { Component, Suspense } from "react";
import ContentWrapper from "./../../../template/Layout/ContentWrapper";
import { Tab, Dropdown } from "semantic-ui-react";
import Documents from "../../Components/Documents";
import queryString from "query-string";
import { withRouter } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import axios from "axios";
import { Services } from "../../../../repositories/clients/Services";
import Loader from "../../../Global/Loader";
import { withNamespaces } from "react-i18next";
import FormCreator from "../../Components/FormBuilder";
import { form_po_visibility } from "./Sumary/components/formsDispatch.js";
import { model_po_visibility } from "./Sumary/components/modelDispatch.js";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";

const SumaryDetail = React.lazy(() => import("./Sumary/SumaryDetail"));

const options = [
  { key: 1, text: "US units", value: 1 },
  { key: 2, text: "Metric units", value: 2 },
];

class DispatchDetail extends Component {
  state = {
    placeholder: "US units",
    isMobil: false,
    firstLoadDocs: true,
    scrollLine: true,
    tabActive: 0,
    fullLoader: false,
    markers: [],
    Resumen: [],
    polylineData: [],
    dataMap: [],
    id: this.props.match.params.id,
    rolId: this.props._rolId,
    userId: this.props._user,
    allSteps: [],
    documentos: [],
    AllcommentsData: [
      {
        id: 1,
        title: this.props.t("request"),
        data: [
          {
            expanded: false,
            id: "TP-SEA-2022-0025",
            message: [],
          },
          {
            expanded: false,
            id: "TP-SEA-2022-234",
            message: [],
          },
        ],
      },
      {
        id: 2,
        title: this.props.t("transport_plan"),
        data: [
          {
            expanded: false,
            id: "EP/COA/AI/S0025",
            message: [],
          },
        ],
      },
    ],
    commentsData: [],
    users: [],
    tables: [
      {
        columns: [
          {
            label: "",
            key: "",
            minWidth: 70,
            maxWidth: 70,
            custom: (value) =>
              value.MarkUrl ? (
                <a href={value.MarkUrl}>
                  <i
                    className="icon-file-image"
                    style={{
                      color: "#0060A8",
                      fontSize: "22px",
                    }}
                  ></i>
                </a>
              ) : (
                ""
              ),
          },

          {
            label: this.props.t("receive_Line"),
            key: "Line",
          },
          {
            label: this.props.t("receive_Shipment"),
            key: "Shipment",
            custom: (value) =>
              value.ShipmentId ? (
                <div class="mb-mail-from">
                  <center>
                    <Link
                      className="linkDetail"
                      to={"/shipmentsDetail/" + value.ShipmentId}
                    >
                      {value.Shipment}
                    </Link>
                  </center>
                </div>
              ) : (
                <span>{value.Shipment}</span>
              ),
          },
          {
            label: this.props.t("receive_Status"),
            key: "ShipmentStatus",
            custom: (value) => (
              <span class="badge badge-euro">{value.ShipmentStatus}</span>
            ),
          },
          { label: this.props.t("receive_PackagesID"), key: "PackageID" },
          { label: this.props.t("receive_Type"), key: "Type" },
          { label: this.props.t("receive_Location"), key: "Location" },
          { label: this.props.t("receive_Grossweight"), key: "Grossweight" },
          { label: this.props.t("receive_Length"), key: "Length" },
          { label: this.props.t("receive_Width"), key: "Width" },
          { label: this.props.t("receive_Height"), key: "Height" },
          { label: this.props.t("receive_Volume"), key: "Volume" },
        ],
        data: [],
        title: this.props.t("sumary_packages"),
        key: "Rutas",
      },
    ],
    model: { ...model_po_visibility() },
  };

  currencyFormatter({ currency, value }) {
    const formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      currency,
    });
    return formatter.format(value);
  }

  componentDidMount = async () => {
    const searchParams = new URLSearchParams(document.location.search);

    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);

    this.setState({
      isMobil: isMobileDevice,
      tabActive: Boolean(searchParams.get("tab"))
        ? Number(searchParams.get("tab"))
        : 0,
    });

    const isNotify = queryString.parse(this.props.location.search);
    let notifyActiveComment = false;

    if (isNotify.nofify) {
      notifyActiveComment = true;
    }

    Promise.all([
      this.getShipmentsForId(),
      this.getEvents(notifyActiveComment),
    ]).finally(() => {
      this.findShipmentDocument();
      this.setState({ fullLoader: true });
    });
  };

  componentWillReceiveProps = (nextProps) => {
    const isNotify = queryString.parse(nextProps.location.search);
    let notifyActiveComment = false;

    if (isNotify.nofify) {
      notifyActiveComment = true;
    }

    const newProp = nextProps.match.params.id
      ? nextProps.match.params.id
      : this.props.match.params.id;
    this.setState({ id: newProp, fullLoader: false }, () => {
      Promise.all([
        this.getShipmentsForId(),
        this.getEvents(notifyActiveComment),
      ]).finally(() => {
        this.findShipmentDocument();
        this.setState({ fullLoader: true });
      });
    });
  };

  getEvents = async (notifyActiveComment) => {
    try {
      const searchParams = new URLSearchParams(document.location.search);
      const { id } = this.state;
      const response = await axios.get(
        `${Services.WAREHOUSE.path}intransit/shipmentevents/${id}?lang=${this.props.lng}&module=dispatch`
      );
      const dataEvents = response.data.data;
      const newSteps = response.data.steps;
      this.setState({
        steps: newSteps,
        allSteps: dataEvents,
        tabActive: Boolean(searchParams.get("tab"))
          ? Number(searchParams.get("tab"))
          : notifyActiveComment
          ? 2
          : 0,
      });
    } catch (error) {
      console.log(
        "🚀 ~ file: ShipmentsDetail.js ~ DispatchDetail ~ getEvents= ~ error",
        error
      );
    }
  };

  handleBack = () => {};

  getShipmentsForId = async () => {
    try {
      const success = await axios.get(
        `${Services.WAREHOUSE.path}intransit/dataShipments/${this.state.id}?user=${this.props._user}&lang=${this.props.lng}`
      );
      let Info = [];
      Info.push(success.data.infoEmbarque);
      success.data.infoEmbarque.TotalWeight = success.data.infoEmbarque
        .TotalWeight
        ? success.data.infoEmbarque.TotalWeight + " LB"
        : "";
      success.data.infoEmbarque.Totalvolume = success.data.infoEmbarque
        .Totalvolume
        ? success.data.infoEmbarque.Totalvolume + " M3"
        : "";
      const data = success.data.infoEmbarque;
      let modelSummary = { ...this.state.model.dispatch_summary };

      modelSummary.Consignor.value = data.Consignor;
      modelSummary.Consignee.value = data.Consignee;
      modelSummary.ReferenceNo.value = data.ReferenceNo;
      modelSummary.Destination.value = data.Destination;
      modelSummary.Numberpackages.value = data.Numberpackages;

      modelSummary.DCNRelease.value = data.DCNRelease;
      modelSummary.Load.value = data.Load;
      modelSummary.Unloaded.value = data.Unloaded;
      modelSummary.Finalized.value = data.Finalized;
      modelSummary.TotalWeight.value = data.TotalWeight;
      modelSummary.Totalvolume.value = data.Totalvolume;

      const model = { ...this.state.model };
      model.dispatch_summary = modelSummary;
      let netTabla = this.state.tables.map((f) => {
        f.data =
          success.data.packages && success.data.packages.length > 0
            ? success.data.packages
            : success.data.packages
            ? [success.data.packages]
            : [{}];
        return f;
      });
      this.setState({
        model,
        tables: netTabla,
        shipment: success.data.infoEmbarque,
        shipmentBackup: success.data.infoEmbarque,
        packageBackup: netTabla[0].data,
        DoEmbarque: success.data.infoEmbarque ? Info[0].DoEmbarque : "",
        ModoTransporte: success.data.infoEmbarque ? Info[0].ModoTransporte : "",
        cliente: success.data.infoEmbarque ? Info[0].Cliente : "",
      });
    } catch (error) {
      console.log(
        "🚀 ~ file: ShipmentsDetail.js ~ DispatchDetail ~ getShipmentsForId= ~ error",
        error
      );
    }
  };

  findShipmentDocument = async () => {
    try {
      let resp = await axios.get(
        `${Services.WAREHOUSE.path}intransit/docShipments/${this.state.shipment.TransactionNo}?user=${this.props._user}&lang=${this.props.lng}&module=TransitDispatch`
      );
      //LIMITAR DOCUMENTOS POR ROL
      let Documents = [];
      if (resp.data.data && resp.data.data.length > 0) {
        Documents = resp.data.data;
        this.setState({ documentos: Documents });
      }
    } catch (error) {
      console.log("findShipmentDocument", error);

      this.setState({ documentos: [] });
    }
  };

  convertUinits = (e, { value }) => {
    const inch = 2.54;
    const lb = 2.205;
    const netTabla = Array.from(this.state.tables);
    let infoConvert = { ...this.state.shipmentBackup };
    const model = JSON.parse(JSON.stringify(this.state.model));
    switch (value) {
      case 2:
        if (infoConvert.TotalWeight) {
          const TotalWeight = Number(infoConvert.TotalWeight.split(" ")[0]);
          model.dispatch_summary.TotalWeight.value = `${(
            TotalWeight / lb
          ).toFixed(2)} Kg`;
        }

        //let packages = [...this.state.packageBackup];
        let packages = JSON.parse(JSON.stringify(this.state.packageBackup));

        packages = packages.map((p) => {
          const grossweight = Number(p?.Grossweight.split(" ")[0]);
          p.Grossweight = `${(grossweight / lb).toFixed(2)} Kg`;

          const length = Number(p?.Length.split(" ")[0]);
          p.Length = `${(length * inch).toFixed(2)} cm`;

          const Width = Number(p?.Width.split(" ")[0]);
          p.Width = `${(Width * inch).toFixed(2)} cm`;

          const Height = Number(p?.Height.split(" ")[0]);
          p.Height = `${(Height * inch).toFixed(2)} cm`;

          return p;
        });
        netTabla[0].data = [...packages];
        break;
      case 1:
        model.dispatch_summary.TotalWeight.value =
          this.state.shipmentBackup.TotalWeight;
        netTabla[0].data = [...this.state.packageBackup];
        break;
      default:
        break;
    }

    if (value) {
      this.setState({
        model,
        tables: netTabla,
      });
    }
  };

  render() {
    let {
      Resumen,
      tables,
      shipment,
      fullLoader,
      tabActive,
      isMobil,
      model,
      placeholder,
    } = this.state;

    return (
      <>
        <Loader hidden={fullLoader} />
        <ContentWrapper>
          <div>
            <div className="content-heading header-seacargo">
              <legend className="legendBasic">
                <i
                  className="icon-warehouse-solid-2"
                  style={{ marginRight: "5px" }}
                ></i>
                {`${" " + this.props.t("dispatch")}`}
              </legend>
              <div className="_btnBack d-flex align-items-center">
                <Icon.Group>
                  <Icon
                    name="angle left"
                    onClick={() => this.props.history.push("/warehousing")}
                  />
                </Icon.Group>
                <span
                  className="_text_btn-back"
                  onClick={() => this.props.history.push("/warehousing")}
                >
                  {this.props.t("back")}
                </span>
              </div>
            </div>
          </div>
          <Tab
            menu={{
              secondary: true,
              className: "wrapped",
              pointing: true,
              style: { fontSize: "14px" },
            }}
            menuPosition="right"
            onTabChange={(event, data) => {
              if (data.activeIndex === 2 && this.state.firstLoadDocs) {
                this.setState({ firstLoadDocs: false });
              }
              this.setState({ tabActive: data.activeIndex });
            }}
            activeIndex={tabActive}
            panes={[
              {
                menuItem: this.props.t("summary"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    <hr></hr>
                    <Row className="d-flex justify-content-end">
                      <Col
                        xs={2}
                        sm={3}
                        md={3}
                        lg={2}
                        xl={2}
                        xxl={2}
                        className="_align _name"
                      >
                        <Dropdown
                          fluid
                          search
                          selection
                          compact
                          clearable
                          options={options}
                          onChange={this.convertUinits}
                          className="dropdown-formbuilder"
                          upward={false}
                          placeholder={placeholder}
                        />
                      </Col>
                    </Row>
                    <SumaryDetail
                      Resumen={Resumen}
                      tables={tables}
                      shipment={shipment}
                      steps={this.state.steps}
                      form_creator={FormCreator}
                      form_component={form_po_visibility}
                      model={model}
                    />
                  </Suspense>
                ),
              },
              /* {
                menuItem: this.props.t("events"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    <hr></hr>
                    <Events
                      cliente={this.state.cliente}
                      NIT={this.state.NIT}
                      Grupo={this.state.Grupo}
                      logoUrl={logoUrl}
                      DoEmbarque={this.state.DoEmbarque}
                      HBL_HAWB={this.state.HBL_HAWB}
                      Estatus={this.state.Estatus}
                      allSteps={this.state.allSteps}
                      steps={this.state.steps}
                    />{" "}
                  </Suspense>
                ),
              },*/
              {
                menuItem: this.props.t("documents"),
                render: () => (
                  // <div>
                  <Suspense fallback={<div>Loading...</div>}>
                    <div
                      className="content-wrapper"
                      style={{ paddingRight: "0", paddingLeft: "0" }}
                    >
                      <Documents
                        dataDoc={this.state.documentos}
                        docBase64={true}
                        rolId={1}
                        shipment=""
                        shipmentDataPlane=""
                        isMobil={isMobil}
                      />
                    </div>
                  </Suspense>
                ),
              },
            ]}
          />
        </ContentWrapper>
      </>
    );
  }
}
export default withNamespaces()(withRouter(DispatchDetail));
